module.exports = {"330483001":"梧桐街道","330483003":"凤鸣街道","330483004":"高桥街道","330483100":"乌镇镇","330483101":"濮院镇","330483102":"屠甸镇","330483103":"石门镇","330483104":"河山镇","330483105":"洲泉镇","330483106":"大麻镇","330483107":"崇福镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330483.json
// module id = 985
// module chunks = 0